<--- 自媒体 推广 -->
<template>
  <div class="container" v-if="isShow">
    <img :src="currentBg" alt="" class="img" />
    <div
      class="input-container"
      :class="{ jzs1: shortName == 'jzs1', jzs2: shortName == 'jzs2', aqs: shortName == 'aqs', jjs: shortName == 'jjs', ky: shortName == 'ky' }"
    >
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入您的手机号，仅开课使用，已加密" v-model="formData.mobile" />
      </div>
      <div class="input-box">
        <input type="text" maxlength="15" placeholder="请输入验证码" v-model="formData.msg" />
        <div class="code" @click="sendMsg">
          获取验证码<span v-if="codeTime != 60">({{ codeTime }})</span>
        </div>
      </div>
      <template v-if="shortName != 'ky'">
        <div class="radio-wrapper">
          <div class="radio-item" v-for="(item, index) in filterList" :key="index" @click="radioChange(index)">
            <img src="@/assets/imgs/check_box_selected.png" v-if="item.isSelected" />
            <img src="@/assets/imgs/check_box.png" v-else />
            <span>{{ item.name }}</span>
          </div>
        </div>
      </template>

      <div class="submit" @click="onsubmit" />
    </div>
  </div>
</template>

<script>
import { enrollPwd, sendMsg } from '@/api/index'
import md5 from 'js-md5'
import { phoneValidator } from '@/utils'
export default {
  data() {
    return {
      codeTime: 60,
      formData: {
        mobile: '',
        msg: ''
      },
      list: [
        {
          name: '建筑全科',
          shortName: 'jzs1',
          id: 'BK202407240001',
          promotedAccount: '自主注册-新媒体短视频-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: '0f1a6cdc42de4ca38ad8674014d71b9a',
              subjectid: '69e46917cfdf4fa1a103ce044b368051'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs1',
          id: 'BK202407240001',
          promotedAccount: '自主注册-新媒体短视频-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '629ed1ef034d4ab8a1e5ac86e8151d2d',
              subjectid: '8c0126ad336c470ab786631fd3a0b64e'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs1',
          id: 'BK202407240001',
          promotedAccount: '自主注册-新媒体短视频-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: 'd1c494a5b64848bc8b7ebe30e4bac237',
              subjectid: '7b44758158d24726ab0a3a627c1e4c84'
            }
          ]
        },

        {
          name: '公路全科',
          shortName: 'jzs1',
          id: 'BK202407240001',
          promotedAccount: '自主注册-新媒体短视频-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: '6e3863be8d1e4ee3bce2748fc7b69c99',
              subjectid: 'fb34520de9d046ee93a974f0b1e2642b'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs1',
          id: 'BK202407240001',
          promotedAccount: '自主注册-新媒体短视频-一建',
          collegeName: '一级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '1cdc3ffdd3d64819b764f159cc432150',
              subjectid: '7a57c2fdc74b465aa3810a456958c781'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jzs2',
          id: 'BK202407240002',
          promotedAccount: '自主注册-新媒体短视频-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '建筑全科',
              worthid: 'f8f4f3b61b334140933b1ee6a6da2c40',
              subjectid: '3bdfeeff79834aa08cf1f34f68143cbd'
            }
          ]
        },
        {
          name: '机电全科',
          shortName: 'jzs2',
          id: 'BK202407240002',
          promotedAccount: '自主注册-新媒体短视频-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '机电全科',
              worthid: '76a1c27e4a4e4ff6a7380482800eaff3',
              subjectid: '0137751bebf94548a39f4c78ab8caa20'
            }
          ]
        },
        {
          name: '市政全科',
          shortName: 'jzs2',
          id: 'BK202407240002',
          promotedAccount: '自主注册-新媒体短视频-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '市政全科',
              worthid: '16a03fd298834133baf1a4a632fc0765',
              subjectid: '704086d0180f439d882cb671c232e9ce'
            }
          ]
        },
        {
          name: '公路全科',
          shortName: 'jzs2',
          id: 'BK202407240002',
          promotedAccount: '自主注册-新媒体短视频-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '公路全科',
              worthid: 'a28ecac842844c8b81e5fade8cb3c460',
              subjectid: '9f6a0901dd8746d3ac6ec25669f05482'
            }
          ]
        },
        {
          name: '水利全科',
          shortName: 'jzs2',
          id: 'BK202407240002',
          promotedAccount: '自主注册-新媒体短视频-二建',
          collegeName: '二级建造师',
          subjectList: [
            {
              name: '水利全科',
              worthid: '1b68655f01064ebdaea262ffa6f29c38',
              subjectid: 'dd28111117f141afb53192d079fa2bc0'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '建筑施工安全全科',
              worthid: '32aa4e6bc1814741b9fe65a03e6b8a93',
              subjectid: '6d50bafdbf2b40ffa4eb85bb861d4ace'
            }
          ]
        },
        {
          name: '化工全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '化工安全全科',
              worthid: 'b4b5fbd2b69a4f728b7f006fe2363577',
              subjectid: 'a7c4f50d5ce94eef9ee8880ca2f4cc71'
            }
          ]
        },
        {
          name: '煤矿全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '煤矿安全全科',
              worthid: '8c9cadd6042e4e7f872a1bac80916343',
              subjectid: '63a0aa33686b4a56b4477f8696f716e8'
            }
          ]
        },
        {
          name: '其他安全全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '其他安全全科',
              worthid: 'e3301b214c3e4c2faa59c1e42342fb03',
              subjectid: '5382d9e80806476999073b88290cac58'
            }
          ]
        },
        {
          name: '道路运输全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '道路运输安全全科',
              worthid: '88e4504236074287936a6b16823ad34b',
              subjectid: '0d9d3c77fe5b4aabb3c2d8d7da814279'
            }
          ]
        },
        {
          name: '金属冶炼全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属冶炼全科',
              worthid: 'f714c2c5ab5f4d9fa92ea4cf74d72128',
              subjectid: '89f5ce69ccf04c529ac91ed959c695e9'
            }
          ]
        },
        {
          name: '金属非金属全科',
          shortName: 'aqs',
          id: 'BK202407240003',
          promotedAccount: '自主注册-新媒体短视频-注安',
          collegeName: '注册安全工程师',
          subjectList: [
            {
              name: '金属非金属全科',
              worthid: 'b736e7dc479542aa82c297ab0e5b4d41',
              subjectid: 'e0eed484583c49a2817a1b9cd225784b'
            }
          ]
        },
        {
          name: '工商全科',
          shortName: 'jjs',
          id: 'BK202409100001',
          promotedAccount: '自主注册-新媒体短视频-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '工商管理全科',
              worthid: '2f4850b32a054ee88a0f0fc9afc60a50',
              subjectid: 'd486254753064e4ea9c0208ea078b6b1'
            }
          ]
        },
        {
          name: '人力全科',
          shortName: 'jjs',
          id: 'BK202409100001',
          promotedAccount: '自主注册-新媒体短视频-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '人力资源全科',
              worthid: 'ceb67c047e7447eb9bc13899ac8582a2',
              subjectid: 'f2614ddc9da14247820b0a4f877a8ea8'
            }
          ]
        },
        {
          name: '财税全科',
          shortName: 'jjs',
          id: 'BK202409100001',
          promotedAccount: '自主注册-新媒体短视频-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '财政税收全科',
              worthid: '157b9d21b4ce4a508c27cc38ca769e84',
              subjectid: '353eee8c648e414e9484673cfc8336eb'
            }
          ]
        },
        {
          name: '金融全科',
          shortName: 'jjs',
          id: 'BK202409100001',
          promotedAccount: '自主注册-新媒体短视频-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '金融全科',
              worthid: '52ac18cc3fba49bfa53e1d26d0662ff0',
              subjectid: 'df80ab10f09e4cdfb17d4f6ebc038836'
            }
          ]
        },
        {
          name: '建筑全科',
          shortName: 'jjs',
          id: 'BK202409100001',
          promotedAccount: '自主注册-新媒体短视频-中经',
          collegeName: '中级经济师',
          subjectList: [
            {
              name: '建筑与房地产全科',
              worthid: 'bb1b692e5c7b47d988df9e2bbb6ebfe4',
              subjectid: 'dd8f7c27d2d543feb30f558f00cd7683'
            }
          ]
        },
        {
          name: '英语（一）',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（一）',
              worthid: '4d5829d4306744c5bd35aa5314e421d8',
              subjectid: '059b5d68a0f64f7da7dfbc034485536c'
            }
          ]
        },
        {
          name: '英语（二）',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '英语（二）',
              worthid: 'ee755388ea354fe19a355481cb84b3e8',
              subjectid: '318bce61f95740d1aed00a31ea465d23'
            }
          ]
        },
        {
          name: '思想政治理论',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '思想政治理论',
              worthid: '0ddaaba4d00048bdbc9f645815403794',
              subjectid: '106facca9bad454d8e44b8b772d76166'
            }
          ]
        },
        {
          name: '数学（一）',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '数学（一）',
              worthid: 'ec16b654586c409598e7a7eab00656f3',
              subjectid: '6545d2a56d594562b7db97e65b44b667'
            }
          ]
        },
        {
          name: '数学（二）',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '数学（二）',
              worthid: 'd7c1bdad4fdd46b5951ba05e697c2760',
              subjectid: '6d485fc3920042eb926718f7f77f5174'
            }
          ]
        },
        {
          name: '数学（三）',
          shortName: 'ky',
          id: 'BK202407240004',
          promotedAccount: '自主注册-新媒体短视频-考研',
          collegeName: '研究生招生初试',
          subjectList: [
            {
              name: '数学（三）',
              worthid: '521117ea62d94f37a41e1737b18ace72',
              subjectid: '70e3a9f7a5b34c7bb6d3e587597a683c'
            }
          ]
        }
      ],
      bgImgList: {
        jzs1: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/xwtg/xwtg_jzs1_bg.jpg',
        jzs2: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/xwtg/xwtg_jzs2_bg.jpg',
        aqs: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/xwtg/xwtg_aqs_bg.jpg',
        jjs: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/xwtg/xwtg_jjs_bg.jpg',
        ky: 'https://zk-web-source.oss-cn-beijing.aliyuncs.com/h5/promotion/xwtg/xwtg_ky_bg.jpg'
      },
      shortName: '',
      currentCourse: {},
      //发送验证码
      isCodeClickable: true,
      isShow: false,
      filterList: []
    }
  },
  methods: {
    radioChange(index) {
      this.filterList.forEach(item => (item.isSelected = false))
      const current = this.filterList[index]
      current.isSelected = true
      this.$set(this.filterList, index, current)
    },
    sendMsg() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }
      if (!this.isCodeClickable) {
        return
      }
      sendMsg({
        phone: this.formData.mobile,
        type: 1,
        corpId: '123456789'
      }).then(res => {
        this.isCodeClickable = false
        this.setCodeTime()
      })
    },
    setCodeTime() {
      const copy = this.codeTime
      const interval = setInterval(() => {
        let codeTime = this.codeTime - 1
        if (this.codeTime === 0) {
          clearInterval(interval)
          codeTime = copy
          this.isCodeClickable = true
        }
        this.codeTime = codeTime
      }, 1000)
    },
    onsubmit() {
      if (!this.formData.mobile) {
        this.$toast.center('请输入手机号')
        return
      }
      if (!phoneValidator(this.formData.mobile)) {
        this.$toast.center('手机号格式错误')
        return
      }

      if (!this.formData.msg) {
        this.$toast.center('请输入验证码')
        return
      }

      if (!this.filterList.find(item => item.isSelected)) {
        this.$toast.center('请选择科目')
        return
      } else {
        //考研默认选中全部课程
        if (this.shortName == 'ky') {
          this.currentCourse.id = this.filterList[0].id
          let subjectList = []
          this.filterList.forEach(item => {
            subjectList.push(...item.subjectList)
          })
          this.currentCourse.subjectList = subjectList
        } else {
          this.currentCourse = this.filterList.find(item => item.isSelected)
        }
      }

      const gt = new Date().getTime().toString()
      enrollPwd({
        time: gt,
        encryPwd: md5(gt + 'verify'),
        ...this.formData,
        classid: this.currentCourse.id,
        subjectid: this.currentCourse.subjectList.map(item => item.subjectid).join(','),
        worthid: this.currentCourse.subjectList.map(item => item.worthid).join(','),
        collegeName: this.currentCourse.collegeName,
        orign: '自主注册',
        promotedAccount: `${this.currentCourse.promotedAccount}`
      }).then(res => {
        this.$toast.center('提交成功')
        this.formData.mobile = ''
        this.formData.msg = ''
        setTimeout(() => {
          window.location.href = 'https://www.zhongke3.com/zj-app-h5/previewqr/1834884945745973248'
        }, 2000)
      })
    }
  },
  created() {
    this.shortName = this.$route.params.name
    this.filterList = this.list.filter(item => item.shortName === this.shortName)
    if (this.filterList.length) {
      //考研默认全选
      if (this.shortName == 'ky') {
        this.filterList.forEach(item => (item.isSelected = true))
      }
      this.currentBg = this.bgImgList[this.shortName]
      this.isShow = true
    }
  }
}
</script>
<style>
body {
  min-width: 100%;
}
@media screen and (min-width: 750px) {
  body {
    max-width: 750px;
    min-width: 750px;
    margin: 0 auto;
  }
}
</style>
<style lang="scss" scoped>
.container {
  display: flex;
  justify-content: center;
  position: relative;
  width: 100%;
  &::-webkit-scrollbar {
    display: none;
  }
  .img {
    position: absolute;
    width: 100%;
    top: 0;
    vertical-align: bottom;
    z-index: 0;
  }
  .input-container {
    position: relative;
    height: 53vw;
    width: 100%;

    z-index: 1;

    .input-box {
      display: flex;
      align-items: center;
      margin-bottom: 8px;
      padding: 0 9.5vw;
      input {
        flex: 1;
        outline: none;
        padding-left: 10px;
        border: 1px solid rgb(172, 173, 175);
        border-radius: 5px;
        font-size: 12px;
        height: 12.6vw;
        box-shadow: none;
        box-sizing: border-box;
        background: #fff;
      }
      .code {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-left: 10px;
        color: #fff;
        font-size: 13px;
        width: 99px;
        height: 12.6vw;
        border-radius: 5px;
        span {
          color: #fff;
        }
      }
    }
    .radio-wrapper {
      display: flex;
      flex-wrap: wrap;
      padding-left: 9vw;
      padding-top: 2.5vw;

      .radio-item {
        display: flex;
        align-items: center;
        margin-bottom: 1vw;
        &:not(:last-child) {
          margin-right: 5px;
        }
        img {
          width: 4.5vw;
          height: 4.5vw;
          margin-right: 0.6vw;
        }
        span {
          font-size: 4.3vw;
          color: #333;
        }
      }
    }
    &.jzs1,
    &.jzs2,
    &.jjs,
    &.ky {
      padding: 150vw 0 0;
      .radio-wrapper {
        .radio-item {
          margin-right: 5vw;
          &:nth-child(2) {
            margin-right: 19vw;
          }
        }
      }
    }
    &.jzs1 {
      .input-box {
        .code {
          background: rgb(21, 87, 241);
        }
      }
    }

    &.jzs2 {
      .input-box {
        .code {
          background: rgb(92, 209, 252);
        }
      }
    }

    &.aqs {
      padding: 148vw 0 0;
      .input-box {
        .code {
          background: rgb(253, 135, 38);
        }
      }
      .radio-wrapper {
        .radio-item {
          margin-right: 5vw;
        }
      }
    }

    &.jjs {
      .input-box {
        .code {
          background: rgb(70, 187, 254);
        }
      }
    }

    &.ky {
      .input-box {
        .code {
          background: rgb(126, 143, 247);
        }
      }
    }

    .submit {
      display: flex;
      justify-content: center;
      align-items: center;
      font-weight: bold;
      margin: 21px auto 0;
      color: #fff;
      font-size: 14px;
      border-radius: 2px;
      height: 100%;
      width: 90%;
      background: none;
    }
  }
}
@media screen and (min-width: 750px) {
  .container {
    .input-container {
      position: relative;
      height: 53vw;
      width: 100%;

      z-index: 1;

      .input-box {
        display: flex;
        align-items: center;
        margin-bottom: 30px;
        padding: 0 60px;
        input {
          flex: 1;
          outline: none;
          padding-left: 10px;
          border: 1px solid rgb(172, 173, 175);
          border-radius: 5px;
          font-size: 12px;
          height: 60px;
          box-shadow: none;
          box-sizing: border-box;
          background: #fff;
        }
        .code {
          display: flex;
          justify-content: center;
          align-items: center;
          margin-left: 10px;
          color: #fff;
          font-size: 13px;
          width: 99px;
          height: 60px;
          border-radius: 5px;
          cursor: pointer;
          span {
            color: #fff;
          }
        }
      }
      .radio-wrapper {
        display: flex;
        flex-wrap: wrap;
        padding-left: 9vw;
        padding-top: 65px;

        .radio-item {
          display: flex;
          align-items: center;
          margin-bottom: 1vw;
          cursor: pointer;
          &:not(:last-child) {
            margin-right: 5px;
          }
          img {
            width: 20px;
            height: 20px;
            margin-right: 10px;
          }
          span {
            font-size: 18px;
            color: #333;
          }
        }
      }
      &.jzs1,
      &.jzs2,
      &.jjs,
      &.ky {
        padding: 1110px 0 0;
        .radio-wrapper {
          .radio-item {
            margin-right: 30px;
            &:nth-child(2) {
              margin-right: 30px;
            }
          }
        }
      }
      &.jzs1 {
        .input-box {
          .code {
            background: rgb(21, 87, 241);
          }
        }
      }

      &.jzs2 {
        .input-box {
          .code {
            background: rgb(92, 209, 252);
          }
        }
      }

      &.aqs {
        padding: 1100px 0 0;
        .input-box {
          .code {
            background: rgb(253, 135, 38);
          }
        }
        .radio-wrapper {
          .radio-item {
            margin-right: 30px;
            &:nth-child(2) {
              margin-right: 30px;
            }
          }
        }
      }

      &.jjs {
        .input-box {
          .code {
            background: rgb(70, 187, 254);
          }
        }
      }

      &.ky {
        .input-box {
          .code {
            background: rgb(126, 143, 247);
          }
        }
      }

      .submit {
        display: flex;
        justify-content: center;
        align-items: center;
        font-weight: bold;
        margin: 21px auto 0;
        color: #fff;
        font-size: 14px;
        border-radius: 2px;
        height: 100%;
        width: 90%;
        background: none;
        cursor: pointer;
      }
    }
  }
}
</style>
